<template>
  <div>
    <h2>
      <span class="step-name"> Sheep - Production </span>
      <comments field-name="heading_animal_numbers_sheep"></comments>
    </h2>

    <div class="step-section">
      <h3>Vaccines purchased Last Season</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Purchase Date</th>
            <th>Animal Name</th>
            <th>Stock Code - Name</th>
            <th>Quantity</th>
            <th>Doses</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('sheep_repro_vax_purchases')" :key="index">
            <td class="text-left">{{ row['Purchase Date'] }}</td>
            <td class="text-left">{{ row['Animal Name'] }}</td>
            <td class="text-left">{{ row['Stock Code - Name'] }}</td>
            <td class="text-left">{{ row['Quantity'] }}</td>
            <td class="text-left">{{ row['Doses'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <h3>Testing Results</h3>
      <span> (BROVCF, HELIPCR, TOXOPCR, CFF 5915, CFF 134, CFF DL42, CFF 6/1, HSDABP, TOXLA) </span>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Date</th>
            <th>Animal Name</th>
            <th>Vet</th>
            <th>Description</th>
            <th>Test Type</th>
            <th>Number of Tests</th>
            <th>Results</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('sheep_repro_tests_table')" :key="index">
            <td class="text-left">{{ row['Date'] }}</td>
            <td class="text-left">{{ row['Animal Name'] }}</td>
            <td class="text-left">{{ row['Vet'] }}</td>
            <td class="text-left">{{ row['Description'] }}</td>
            <td class="text-left">{{ row['Test Type'] }}</td>
            <td class="text-left">{{ row['Number of Tests'] }}</td>
            <td class="text-left">{{ row['Results'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <h3>Ewe Vaccinations</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th></th>
            <th>Age 1st Vax H, 2th, MA</th>
            <th>1st Shot Month</th>
            <th>Booster Month</th>
            <th>Annual Month</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Toxovax</strong></td>
            <td>
              <text-input :show-input-box="false" field-name="toxovax_age"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="toxovax_sens"></text-input>
            </td>
            <td style="background: #eee"></td>
            <td style="background: #eee"></td>
          </tr>
          <tr>
            <td><strong>CampyVax4</strong></td>
            <td>
              <text-input :show-input-box="false" field-name="campy_age"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="campy_sens"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="campy_boost"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="campy_annual"></text-input>
            </td>
          </tr>
          <tr>
            <td><strong>Salvexin +B</strong></td>
            <td>
              <text-input :show-input-box="false" field-name="salvex_age"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="salvex_sens"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="salvex_boost"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="salvex_annual"></text-input>
            </td>
          </tr>
          <tr>
            <td><strong>Ovastim/Androvax</strong></td>
            <td>
              <text-input :show-input-box="false" field-name="ovas_andro_age"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="ovas_andro_sens"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="ovas_andro_boost"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="ovas_andro_annual"></text-input>
            </td>
          </tr>
          <tr>
            <td><strong>Clostridial</strong></td>
            <td>
              <text-input :show-input-box="false" field-name="clostri_age"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="clostri_sens"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="clostri_boost"></text-input>
            </td>
            <td>
              <text-input :show-input-box="false" field-name="clostri_annual"></text-input>
            </td>
          </tr>
        </tbody>
      </table>

      <discussion-points
        title="Ewe Vaccinations Discussion Points"
        comments-field="ewe_vax_discussion"
        points="Product (clostridial) timing, human health, storage, changing needles"
      >
      </discussion-points>
    </div>

    <div class="step-section">
      <div class="row">
        <div class="col-md-12">
          <h3>Ewe Reproduction</h3>
        </div>

        <div class="col-md-6">
          <h3>Previous Consult</h3>
          <div class="form-group input-box">
            <label>Tupping Date (Main Mob)</label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').sheep_tupping_date"
              disabled
            />
          </div>
        </div>

        <div class="col-md-6">
          <h3>This Year</h3>

          <date-input
            :placeholder="getFieldValue('PREVIOUS_CONSULT_DATA').sheep_tupping_date"
            field-name="sheep_tupping_date"
            @on-change="updateStartOfLambing"
            label="Tupping Date (Main Mob)"
            required
          >
          </date-input>
        </div>
      </div>

      <date-input field-name="sheep_lambing_start_date" label="Calculated start of Lambing"> </date-input>
    </div>

    <discussion-points
      title="Reproduction Discussion"
      comments-field="reproduction_discussion"
      points="Repro concerns, Length of mating, Teasers used, Condition, Feed availability, Genetics, Wastage, Bearings, Weight, Scanning"
    >
    </discussion-points>

    <div class="step-section">
      <h3>Scanning: MA Ewes (incl. 2 tooths)</h3>
      <br />
      <div class="">
        <strong>What is your scanning target/focus?</strong>
        <comments field-name="scanning_target_focus"></comments>
      </div>
      <br />

      <radio-input
        label="Do you scan for triplets?"
        field-name="sheep_scans_for_triplets"
        :add-comment="true"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group input-box">
            <label>Scanning % (Previous season) </label>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').sheep_ma_scanning_percent"
              disabled
            />
          </div>

          <div class="form-group input-box">
            <label>Lambing % (Previous season) </label>
            <br />
            <small class="form-text text-muted"> (Number of lambs at tailing divided by number of ewes mated) </small>
            <input
              type="text"
              class="form-control"
              :value="getFieldValue('PREVIOUS_CONSULT_DATA').sheep_ma_tailing_percent"
              disabled
            />
          </div>
        </div>

        <div class="col-md-6">
          <number-input field-name="sheep_ma_scanning_percent" label="Scanning % (This season)"> </number-input>

          <number-input
            field-name="sheep_ma_tailing_percent"
            label="Lambing % (This season)"
            subtext="(Number of lambs at tailing divided by number of ewes mated)"
          >
          </number-input>
        </div>
      </div>
    </div>

    <div class="step-section">
      <h3>Scanning History: MA Ewes (incl. 2 tooths)</h3>

      <h4>Scanning %</h4>
      <line-chart :chart-data="getMAData('av_scan', 'Region Average Scanning Percent', 'scan', 'Client Percent')" />

      <h4>Lambing %</h4>
      <line-chart :chart-data="getMAData('av_tail', 'Region Average Tailing Percent', 'tail', 'Client Percent')" />

      <radio-input
        label="Do you BCS regularly?"
        field-name="does_regular_bcs"
        :add-comment="true"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>
    </div>

    <div class="step-section">
      <h3>Ewe Parasite Management</h3>

      <h3>Drench Product Purchases (All ages)</h3>

      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Purchase Date</th>
            <th>Animal Name</th>
            <th>Stock Code - Name</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('sheep_drench_purchases')" :key="index">
            <td class="text-left">{{ row['Purchase Date'] }}</td>
            <td class="text-left">{{ row['Animal Name'] }}</td>
            <td class="text-left">{{ row['Stock Code - Name'] }}</td>
            <td class="text-left">{{ row['Quantity'] }}</td>
          </tr>
        </tbody>
      </table>

      <text-input
        label="Other drench products/actives used"
        field-name="sheep_other_drench_products_actives_used_not_vs"
      >
      </text-input>

      <discussion-points
        title="Ewe Drench Discussion"
        comments-field="ewe_drench_discussion"
        points="Adult drenching policy, pretup/prelamb, alternative management techniques"
      >
      </discussion-points>
    </div>

    <div class="step-section">
      <h3>
        <span>Ewe Trace Elements</span>
        <comments field-name="ewe_trace_elements_comments"></comments>
      </h3>
      <h3>Trace Elements Product Purchases</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Date</th>
            <th>Animal Name</th>
            <th>Stock Code - Name</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('sheep_trace_element_purchases')" :key="index">
            <td class="text-left">{{ row['Purchase Date'] }}</td>
            <td class="text-left">{{ row['Animal Name'] }}</td>
            <td class="text-left">{{ row['Stock Code - Name'] }}</td>
            <td class="text-left">{{ row['Quantity'] }}</td>
          </tr>
        </tbody>
      </table>

      <text-input label="Other TE products used (Pretup, prelamb)" field-name="sheep_other_te_not_vs"> </text-input>

      <h3>Trace Element Test Results (Gpx, Pll)</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Date</th>
            <th>Animal Name</th>
            <th>Vet</th>
            <th>Description</th>
            <th>Lab Animal Name</th>
            <th>Test Type</th>
            <th>Units</th>
            <th>Result</th>
            <th>Range</th>
            <th>HL</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('sheep_te')" :key="index">
            <td class="text-left">{{ row['Date'] }}</td>
            <td class="text-left">{{ row['Animal Name'] }}</td>
            <td class="text-left">{{ row['Vet'] }}</td>
            <td class="text-left">{{ row['Description'] }}</td>
            <td class="text-left">{{ row['Lab Animal Name'] }}</td>
            <td class="text-left">{{ row['Test Type'] }}</td>
            <td class="text-left">{{ row['Units'] }}</td>
            <td class="text-left">{{ row['Result'] }}</td>
            <td class="text-left">{{ row['Range'] }}</td>
            <td class="text-left">{{ row['HL'] }}</td>
          </tr>
        </tbody>
      </table>

      <h3 class="text-left">
        <span class="form-group">
          GPx
          <comments field-name="serum_gpx"></comments>
        </span>
      </h3>
      <box-plot-chart :chart-data="get_gpx_data" />
    </div>

    <div class="step-section">
      <programme-input programme-slug="ovimax"></programme-input>
      <programme-input programme-slug="selenium-monitoring"></programme-input>



      <discussion-points
        title=""
        comments-field="sheep_wants_one_off_te_test"
        points="Approximate timing, what to test for"
      >
        <radio-input
          label="One-off sheep trace element testing?"
          field-name="sheep_wants_one_off_te_test"
          :choices="[
            { value: 'Yes', display: 'Yes' },
            { value: 'No', display: 'No' },
          ]"
          :add-email-notification="true"
          :on-change="toggleNotifications"
          :add-comment="true"
        >
        </radio-input>
      </discussion-points>

      <discussion-points
        title="Trace Element Plan"
        comments-field="sheep_trace_plan_discussion"
        points="Prills - Selenium, Iodine, Selenium, what products do you use and when"
      >
      </discussion-points>

      <discussion-points
        title="Sheep - Other Discussion Topics"
        comments-field="sheep_other_discussion"
        points="Body Condition, Uddering Ewes, Bearings"
      >
      </discussion-points>
    </div>

    <drug-allocation-cart :drugGroups="getFieldValue('DRUG_GROUPS')" animalType="sheep"> </drug-allocation-cart>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import DrugAllocationCart from './DrugAllocationCart'
import LineChart from '@/components/charts/Line'
import BoxPlotChart from '@/components/charts/BoxPlotChart'

export default {
  name: 'SheepReproductionPlan',
  mixins: [baseComponent],
  components: {
    BoxPlotChart,
    DrugAllocationCart,
    LineChart,
  },
  methods: {
    toggleNotifications: function () {
      this.setEmailNotification({
        slug: 'one-off-notes-for-farm-services',
        value:
          this.getFieldValue('sheep_wants_one_off_te_test', this.$options.name) == 'Yes' ||
          this.getFieldComment('sheep_wants_one_off_te_test', this.$options.name).current,
      })
    },
    updateStartOfLambing: function ({ value }) {
      this.setFieldValue({
        modelName: this.$options.name,
        fieldName: 'sheep_lambing_start_date',
        value: this.$moment(value).add(147, 'days').format('YYYY-MM-DD'),
      })
    },
    getMAData: function (field1, label1, field2, label2) {
      let data = Object.assign([], this.getFieldValue('CHARTS')['sheep_ma_scanning']).sort((a, b) =>
        a['year'] < b['year'] ? -1 : 0
      )

      return {
        labels: data.map((row) => row['year']),
        datasets: [
          {
            label: label1,
            pointBackgroundColor: '#3e95cd',
            backgroundColor: '#3e95cd',
            data: data.map((row) => parseFloat(row[field1] || '')),
            fill: false,
          },
          {
            label: label2,
            pointBackgroundColor: 'red',
            backgroundColor: 'red',
            data: data.map((row) => parseFloat(row[field2] || '')),
            fill: false,
          },
        ],
      }
    },
    getLabels(data) {
      return data.map((row) => row['Date'])
    },
    getData(data) {
      return data.map((row) => row['res'].split(', ').map((n) => parseFloat(n)))
    },
  },
  computed: {
    get_gpx_data: function () {
      return {
        labels: this.getLabels(this.getChartData('sheep_gpx_results')),
        datasets: [
          {
            label: 'GPx',
            borderWidth: 2,
            borderColor: 'rgba(0, 0, 0, .4)',
            backgroundColor: 'rgba(51, 122, 183, 0.6)',
            data: this.getData(this.getChartData('sheep_gpx_results')),
          },
        ],
      }
    },
    getOvimaxData: function () {
      let label, value

      if (
        this.getFieldValue('sheep_ovimax_marker') == 'Already registered' ||
        this.getFieldValue('sheep_ovimax_marker') == 'Leave'
      ) {
        label = 'Leave Ovimax (Trace element and condition score monitoring)'
        value = 'Leave'
      } else if (
        this.getFieldValue('sheep_ovimax_marker') == 'Not registered' ||
        this.getFieldValue('sheep_ovimax_marker') == 'Join'
      ) {
        label = 'Join Ovimax (Trace element and condition score monitoring)'
        value = 'Join'
      }
      return [label, [{ value: value, display: 'Yes' }]]
    },
    getSeleniumData: function () {
      let label, value

      if (
        this.getFieldValue('sheep_selenium_monitoring') == 'Already registered' ||
        this.getFieldValue('sheep_selenium_monitoring') == 'Leave'
      ) {
        label = 'Leave Selenium Monitoring (indicate when in notes if changing)'
        value = 'Leave'
      } else if (
        this.getFieldValue('sheep_selenium_monitoring') == 'Not registered' ||
        this.getFieldValue('sheep_selenium_monitoring') == 'Join'
      ) {
        label = 'Join Selenium Monitoring (indicate when in notes if changing)'
        value = 'Join'
      }
      return [label, [{ value: value, display: 'Yes' }]]
    },
  },
}
</script>

<style>
#line-chart {
  margin-bottom: 3em;
}
</style>
